<div class="container mt-3">
  <div class="card shadow-mm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">MENU MASTER FORM</h4>
    </div>

    <div class="card-body">
      <form>
        <div class="row g-3">

          <!-- User ID -->
          <div class="col-md-6">
            <label class="form-label">Menu ID</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_ID"
                   name="MM_ID">
          </div>

          <div class="col-md-6">
            <label class="form-label">Menu Type</label>
           <select class="form-select form-select-mm"
                    [(ngModel)]="user.MM_Type"
                    name="MM_Type">
              <option value="">-- Select --</option>
              <option value="Menu">Menu</option>
              <option value="Label">Label</option>
              
            </select>
          </div>

          
          <div class="col-md-6">
            <label class="form-label">Menu Module</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_Module"
                   name="MM_Module">
          </div>

       
          <div class="col-md-6">
            <label class="form-label">Display Name</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_Display_Name"
                   name="MM_Display_Name">
          </div>

          <!-- Password -->
          <div class="col-md-6">
            <label class="form-label">Router Link</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_Route_Link"
                   name="MM_Route_Link">
          </div>

          
          <div class="col-md-6">
            <label class="form-label">Menu Order No</label>
             <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_Order_No"
                   name="MM_Order_No">
          </div>

           <div class="col-md-6">
            <label class="form-label">Parent ID</label>
             <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_Parent_ID"
                   name="MM_Parent_ID"  >
          </div>
  <div class="col-md-6">
            <label class="form-label">Menu Level</label>
             <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.MM_Menu_Level"
                   name="MM_Menu_Level"  >
          </div>

          
          <!-- <div class="col-md-6">
            <label class="form-label">Created Date</label>
            <input type="date"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_Createddate"
                   name="Um_Createddate"
                   readonly>
          </div> -->

          <!-- Created By -->
          

          <!-- Submit -->
          <div class="col-12">
            <div class="d-grid mt-4">
              <button class="btn btn-primary btn-lg"
                      type="button"
                      (click)="onSubmitUser()">
                 Save Menu
              </button>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>
